import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SurveyUserTypes } from '../../constants-types/Enums';
import { TranslationService } from '../../translations';

@Component({
    selector: 'person-type-radio',
    template: `
        <radio-choice
            [(ngModel)]="personType"
            (ngModelChange)="personTypeChanged.emit(personType)"
            [possibleValues]="radioValues"
            [disabled]="disabled"
        >
        </radio-choice>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PersonTypeRadioComponent,
            multi: true
        }
    ],
    standalone: false
})
export class PersonTypeRadioComponent implements ControlValueAccessor {
    SurveyUserTypes = SurveyUserTypes;

    @Input()
    disabled = false;
    @Output()
    readonly personTypeChanged = new EventEmitter<SurveyUserTypes>();

    // Only used for radio options
    radioValues = [
        { text: this.TR.key('Candidate'), value: SurveyUserTypes.Candidate },
        { text: this.TR.key('Employee'), value: SurveyUserTypes.Employee },
        {
            text: this.TR.key('text.pro.survey.role.other'),
            value: SurveyUserTypes.Other
        }
    ];

    private _personType: SurveyUserTypes;
    private propagateChange = (_: any) => {
        /* No-op required by ControlValueAccessor interface - see registerOnChange */
    };

    constructor(public TR: TranslationService) {}

    /* Meet ControlValueAccessor Interface */
    get personType() {
        return this._personType;
    }
    set personType(val) {
        this._personType = val;
        this.propagateChange(this._personType);
    }
    writeValue(value: any): void {
        this._personType = value;
    }
    registerOnChange(fn: any): void {
        this.propagateChange = (changed) => fn.call(this, changed);
    }
    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
    /** ***************************************/
}
